export const DO_NOT_MAP = "do-not-map";
export const MAP_TO_EXISTING = "map-to-existing";
export const NEW_ITEM = "new-item";
export const SELECT_ITEM = "select-item";
